/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLinkedin = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19.75 13.252c0-3.21-1.994-4.304-3.84-4.304-1.706 0-2.823 1.104-3.143 1.75h-.042V9.244h-3.18V19.75h3.307v-5.696c0-1.52.962-2.258 1.943-2.258.929 0 1.648.522 1.648 2.215v5.74h3.308zM7.81 5.88c0-1.097-.853-1.9-1.906-1.9s-1.907.803-1.907 1.9.853 1.898 1.907 1.898 1.906-.8 1.906-1.897zM18.62 1l.212.005A4.381 4.381 0 0 1 23 5.381V18.62l-.005.212A4.381 4.381 0 0 1 18.619 23H5.38l-.212-.005A4.382 4.382 0 0 1 1 18.619V5.38l.005-.212A4.382 4.382 0 0 1 5.381 1zM7.557 9.235H4.25v10.507h3.307z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLinkedin as Linkedin };
